/* eslint-disable */
import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { EMPTY, from, Observable, throwError, timer } from 'rxjs';
import { catchError, retry, switchMap } from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';
import { ConfigurationService } from '../utils/configuration.service';
import { SessionService } from '../session/session.service';
import { Router } from '@angular/router';
import { UserService } from '@app/admin-station/work-center/user/services/user.service';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class httpRequestInterceptor implements HttpInterceptor {
  private userService: UserService = inject(UserService);
  private authService: AuthService = inject(AuthService);

  constructor(
    private msalService: MsalService,
    private configurationService: ConfigurationService,
    private sessionService: SessionService,
    private router: Router
  ) { }
  siteUrl = this.configurationService.getApiUrl();

  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const userId = this.userService?.getUserLoginData()?.userId;
    const requestCloned = httpRequest.clone({
      headers: httpRequest.headers.set('Accept', 'text/plain').set('ContextUserId', userId ?? ''),
    });

    return next
      .handle(requestCloned)
      .pipe(
        retry({
          count: 2,
          delay: this.shouldRetry,
        })
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          const handling = this.handleError(error, httpRequest, next);
          if (error.status !== 0) {
            return handling;
          } else {
            return EMPTY;
          }
        })
      );
  }

  /**
   * This will retry requests only for 500 errors instead of the generic retry after any error.
   * There's no need to retry 400 errors as they are caused by the client, and they will keep failing if nothing changes.
   * The expception being 408 - Request Timeout
   * @param error
   * @returns retry interval in ms, or error if there's no need to retry
   */
  private shouldRetry(error: HttpErrorResponse): Observable<number> {
    if (error.status >= 500 || error.status === 408) {
      return timer(1000);
    }
    throw error;
  }

  handleError = (error: any, req: HttpRequest<any>, next: HttpHandler) => {
    const extendedMessage = error?.error.Message ?? '';

    switch (error.status) {
      case 500:
        const isSupportCenter = this.router.url.includes('support-center');
         if (!isSupportCenter) {
          this.router.navigate(['/error']);
        }
      case 400:
        error.statusText = 'Bad Request - Validation error.';
        return throwError(() => error);
      case 401:
        const tokenAttempts = Number(this.sessionService.getItem('tokenAttempts') || 0);
        if (tokenAttempts === 0) {
          this.sessionService.setItem('tokenAttempts', tokenAttempts + 1);
          this.requestNewToken(req, next);
        } else {
          error.statusText = 'UnAuthorized - Token is expired or is invalid.';
          this.authService.logout();
          return throwError(() => error);
        }
      default:
        return throwError(() => error);
    }
  };

  private requestNewToken(req: HttpRequest<any>, next: HttpHandler): any {
    const silentRequest = {
      scopes: this.configurationService.getMsalSettings('guard').authRequest.scopes,
      account: this.msalService.instance.getActiveAccount(),
      forceRefresh: false,
    };

    return from(this.msalService.acquireTokenSilent(silentRequest)).pipe(
      switchMap((token: any) => {
        req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
        this.sessionService.setItem('tokenAttempts', 0);
        return next.handle(req);
      }),
      catchError(() => {
        return this.msalService.logout();
      })
    );
  }
}
/* eslint-disable */
